import React, { PureComponent } from 'react'
import styled, { keyframes } from 'styled-components'
import getPalette, { IPalette } from '../../helpers/colors/colors'
import RichTextContent from '../richText/RichTextContent'
const palette: IPalette = getPalette()

interface ITopInformationProps {
	// Plain text or rich text with equations; RichTextContent tells them apart.
	content: string
	type: 'success' | 'alert' | 'info'
	duration: number
	backgroundColor: string
}

interface ITopInformationState {
	state: 'idle' | 'exiting' | 'removed'
}

const barIn = keyframes`
  0% {
    transform: translate(0, -100%);
    animation-timing-function: ease-out;
  }
  100% {
    transform: translate(0, 0);
  }
`

const barOut = keyframes`
  0% {
    transform: translate(0, 0);
    animation-timing-function: ease-out;
  }
  100% {
    transform: translate(0, -100%);
  }
`

const Wrapper = styled.div`
	width: 100%;
	height: 40px;
	overflow: hidden;
`

const Bar = styled.div`
	width: 100%;
	height: 100%;
	animation-fill-mode: forwards;
	animation-duration: 0.5s;
	color: white;
	font-size: 16px;
	line-height: 40px;
	text-align: center;
	&.success {
		background-color: ${palette.success};
	}
	&.alert {
		background-color: ${palette.alert};
	}
	&.topbar_in {
		animation-name: ${barIn};
	}
	&.topbar_out {
		animation-name: ${barOut};
	}
`

class TopInformation extends PureComponent<ITopInformationProps, ITopInformationState> {
	private timeoutId = 0

	constructor(props: ITopInformationProps) {
		super(props)

		this.state = {
			state: 'idle',
		}
	}

	componentDidMount() {
		this.timeoutId = window.setTimeout(() => {
			this.setState({
				state: 'exiting',
			})

			this.timeoutId = window.setTimeout(() => {
				this.setState({
					state: 'removed',
				})
			}, 1000)
		}, this.props.duration)
	}

	static defaultProps = {
		content: '',
		type: 'success',
		duration: 3000,
	}

	render() {
		if (this.state.state === 'removed') {
			return null
		} else {
			const classNames: string[] = [this.props.type]
			if (this.state.state === 'idle') {
				classNames.push('topbar_in')
			} else if (this.state.state === 'exiting') {
				classNames.push('topbar_out')
			}

			const backgroundColor = this.props.backgroundColor || palette.info
			return (
				<Wrapper
					style={{
						backgroundColor,
					}}
				>
					<RichTextContent
						as={Bar}
						className={classNames.join(' ')}
						content={this.props.content}
						// The bar is the text of whatever live region encloses it (Game's out-of-time bar sets
						// role="alert"), so the speech has to be real text next to it, not an accessible name.
						speechOutlet="hiddenText"
						autoFontSizing={false}
						formulaWeight="light"
					/>
				</Wrapper>
			)
		}
	}

	componentWillUnmount() {
		window.clearTimeout(this.timeoutId)
	}
}

export default TopInformation
